'use strict';

module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./~/remarkable/index.js
// module id = 740
// module chunks = 0